<app-help-page mainVideo="export-destinations"
               [tutorials]="['export-destination-ga-cost']"
               [videos]="['export-destinations', 'exports']"></app-help-page>
